import { supabase } from '../../shared/supabase/supabaseClient';

export type PickupDisplayProfile = 'pickup' | 'delivery' | 'both';

export type PickupDisplayRow = {
  id: string;
  label: string;
  profile: PickupDisplayProfile;
  enabled: boolean;
  settings: Record<string, unknown>;
  recovery_url_path: string;
  created_at: string;
  updated_at: string;
};

export async function listPickupDisplays(branchId: string): Promise<PickupDisplayRow[]> {
  const { data, error } = await supabase.rpc('manage_pickup_displays', {
    p_payload: { action: 'list', branchId },
  });
  if (error) throw error;
  return (data ?? []) as PickupDisplayRow[];
}

export async function completePickupDisplayPairing(payload: {
  branchId: string;
  pin: string;
  label: string;
  profile: PickupDisplayProfile;
  pairingSecret?: string | null;
  settings?: Record<string, unknown>;
}): Promise<{ display_token: string; recovery_url_path: string }> {
  const { data, error } = await supabase.rpc('complete_pickup_display_pairing', {
    p_payload: {
      branchId: payload.branchId,
      pin: payload.pin.replace(/\s/g, ''),
      label: payload.label,
      profile: payload.profile,
      pairingSecret: payload.pairingSecret ?? undefined,
      settings: payload.settings ?? {},
    },
  });
  if (error) throw error;
  return data as { display_token: string; recovery_url_path: string };
}

export async function updatePickupDisplay(
  displayId: string,
  patch: {
    label?: string;
    profile?: PickupDisplayProfile;
    enabled?: boolean;
    settings?: Record<string, unknown>;
  },
): Promise<void> {
  const { error } = await supabase.rpc('manage_pickup_displays', {
    p_payload: { action: 'update', displayId, ...patch },
  });
  if (error) throw error;
}

export async function deletePickupDisplay(displayId: string): Promise<void> {
  const { error } = await supabase.rpc('manage_pickup_displays', {
    p_payload: { action: 'delete', displayId },
  });
  if (error) throw error;
}

export async function rotatePickupDisplayToken(
  displayId: string,
): Promise<{ display_token: string; recovery_url_path: string }> {
  const { data, error } = await supabase.rpc('manage_pickup_displays', {
    p_payload: { action: 'rotate_token', displayId },
  });
  if (error) throw error;
  return data as { display_token: string; recovery_url_path: string };
}
